import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import Layout from "../components/Layout";
import { useNavigate } from "react-router-dom";

function ProfilePage() {
  const { token } = useAuth();
  const [config, setConfig] = useState({
    spotify_client_id: "",
    spotify_client_secret: "",
    openai_api_key: ""
  });

  useEffect(() => {
    // Charger la config actuelle
    fetch("/api/me", {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(res => res.json())
    .then(data => setConfig(data));
  }, [token]);

  const handleSave = () => {
    fetch("/api/update_config", {
      method: "POST",
      headers: { 
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}` 
      },
      body: JSON.stringify(config)
    }).then(res => {
      if(res.ok) alert("Configuration sauvegardée !");
    });
  };

  const navigate = useNavigate(); // Hook de navigation

  return (
    <Layout>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h1>Espace Client / Configuration</h1>
        <button onClick={() => navigate("/")} style={{ backgroundColor: "#666", padding: "5px 15px", fontSize: "14px" }}>
          🏠 Accueil
        </button>
      </div>
      <div>
        <h3>Spotify Config</h3>
        <label>Client ID:</label>
        <input 
          value={config.spotify_client_id || ""} 
          onChange={e => setConfig({...config, spotify_client_id: e.target.value})} 
          style={{width: "100%", marginBottom: "10px"}}
        />
        <label>Client Secret:</label>
        <input 
          type="password"
          value={config.spotify_client_secret || ""} 
          onChange={e => setConfig({...config, spotify_client_secret: e.target.value})}
          style={{width: "100%", marginBottom: "10px"}}
        />
        
        <h3>OpenAI Config</h3>
        <label>API Key:</label>
        <input 
          type="password"
          value={config.openai_api_key || ""} 
          onChange={e => setConfig({...config, openai_api_key: e.target.value})}
          style={{width: "100%", marginBottom: "10px"}}
        />
        
        <button onClick={handleSave}>Sauvegarder</button>
      </div>
    </Layout>
  );
}

export default ProfilePage;